import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "編集", -1)
const _hoisted_2 = { class: "grid grid-cols-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-right" }, "名前", -1)
const _hoisted_4 = { class: "text-left ml-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-right mt-2" }, "機材", -1)
const _hoisted_6 = { class: "text-left ml-4 mt-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userName) = $event)),
          class: "border-2 rounded-lg border-blue-400 p-2"
        }, null, 512), [
          [_vModelText, _ctx.userName]
        ])
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.description) = $event)),
          class: "border-2 rounded-lg border-blue-400 p-2"
        }, "\n      ", 512), [
          [_vModelText, _ctx.description]
        ])
      ])
    ]),
    _hoisted_7,
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        class: "border-2 border-blue-400 w-28 p-4 rounded-lg bg-blue-200 hover:bg-blue-600 hover:text-white mt-2",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.update && _ctx.update(...args)))
      }, " 保存 ")
    ])
  ], 64))
}